<div class="modal-header">
    <h3>{{modalData.modalTitle}}</h3>
</div>
<div class="modal-body">
    <div class="alert" [ngClass]="{'alert-default' : modalData.alertLevel === 'default', 'alert-success' : modalData.alertLevel === 'success', 'alert-danger': modalData.alertLevel === 'danger' }" style="white-space: pre-wrap;">{{modalData.modalMessage}}</div>
</div>
<div class="modal-footer flex-container">
    <div class="flex-column">
        <button *ngIf="useCopyButton" type="button" class="btn btn-icon-only btn-outline-dark" title="Copy to Clipboard" (click)="copyClicked()">
            <i class="modus-icons">clipboard_planning</i>
        </button>
    </div>
    <div class="flex-column">
        <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">
            {{closeButtonText}}
        </button>
    </div>
</div>
